import CurrencyTable from './CurrencyTable';

export default CurrencyTable;
